/**
 * Checks if the current date falls within allowed months for Real Property Appeal
 * @returns {boolean} true if current month is December (12) or January (1)
 */
export const isRealPropertyAppealAvailable = () => {
  const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0-11, add 1 for 1-12
  return currentMonth === 12 || currentMonth === 1;
};

/**
 * Gets the available period text for Real Property Appeal
 * @returns {string} Human-readable period
 */
export const getRealPropertyAppealPeriod = () => {
  return 'December 1 - January 31';
};
